export const fieldToWorkflowExtraOptions = (f: FieldDto): WorkflowExtraOptions => ({
    link_target_object_id: f.link_target_object_id,
    options: f.options?.options,
    render_variant: f.options?.render_variant,
})
